import * as React from 'react';
import { registerComponent } from '@avensia/excite';
import { ContentList } from '@avensia/excite-ninetailed';

export default registerComponent<NordicNest.Api.StartPageApiModel>(props => {
  return (
    <main>
      <ContentList {...props.page.content} />
    </main>
  );
});
